import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const API = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:4003' : '');
type Status = { enabled: boolean; linked: boolean; telegramId: string | null; botUsername: string | null };

export default function TelegramPage() {
  const { userAuth } = useApp();
  const [status, setStatus] = useState<Status | null>(null);
  const [password, setPassword] = useState('');
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const request = useCallback(async (method = 'GET', data?: object) => {
    const response = await fetch(`${API}/api/user/telegram${method === 'POST' ? '/link' : ''}`, {
      method, cache: 'no-store', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userAuth.token}` },
      body: data ? JSON.stringify(data) : undefined,
    });
    const body = response.status === 204 ? null : await response.json().catch(() => null);
    if (!response.ok) throw new Error(body?.error || (response.status === 401 ? 'Проверьте пароль и вход в аккаунт.' : `Ошибка ${response.status}`));
    return body;
  }, [userAuth.token]);
  const refresh = useCallback(async () => {
    if (!userAuth.token) return;
    const next: Status = await request(); setStatus(next);
    if (next.linked) { setUrl(''); setPassword(''); }
  }, [request, userAuth.token]);
  useEffect(() => { refresh().catch(e => setError(e.message)); }, [refresh]);
  useEffect(() => {
    if (!url) return;
    const timer = window.setInterval(() => { if (!document.hidden) refresh().catch(() => {}); }, 3000);
    return () => window.clearInterval(timer);
  }, [url, refresh]);
  if (!userAuth.token) return <section className="card" style={{ maxWidth: 560, margin: '24px auto', padding: 24 }}>
    <h1>Telegram-бот</h1><p>Войдите в аккаунт сайта и вернитесь на эту страницу из бота. Если аккаунта ещё нет, сначала зарегистрируйтесь.</p>
    <p><Link to="/login">Войти</Link> · <Link to="/register">Зарегистрироваться</Link></p>
  </section>;
  return <section className="card" style={{ maxWidth: 560, margin: '24px auto', padding: 24 }}>
    <h1>Telegram-бот</h1>
    <p>Свяжите Telegram с этим аккаунтом: покупки, история и пройденный KYC будут общими с сайтом.</p>
    {error && <p role="alert" style={{ color: '#c43c4a' }}>{error}</p>}
    {!status && !error && <p>Загрузка…</p>}
    {status && !status.enabled && <p>Бот этого проекта пока не настроен.</p>}
    {status?.enabled && status.linked && <>
      <p>Telegram ID: <strong>{status.telegramId}</strong>. Аккаунт привязан.</p>
      <p><a href={`https://t.me/${status.botUsername}`} target="_blank" rel="noreferrer">Открыть бота</a></p>
      <button type="button" disabled={busy} onClick={async () => {
        if (!window.confirm('Отвязать Telegram? Бот и его страницы поддержки потеряют доступ к аккаунту.')) return;
        setBusy(true); setError('');
        try { await request('DELETE'); await refresh(); } catch (e) { setError((e as Error).message); }
        finally { setBusy(false); }
      }}>Отвязать Telegram</button>
    </>}
    {status?.enabled && !status.linked && <form onSubmit={async event => {
      event.preventDefault(); if (busy) return;
      setBusy(true); setError(''); setUrl('');
      try { const result = await request('POST', { currentPassword: password }); setUrl(result.url); setPassword(''); }
      catch (e) { setError((e as Error).message); }
      finally { setBusy(false); }
    }}>
      <label style={{ display: 'grid', gap: 8, margin: '16px 0' }}>Пароль аккаунта для подтверждения
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" required maxLength={256} style={{ padding: 12 }} />
      </label>
      <button type="submit" disabled={busy || !password}>Создать ссылку привязки</button>
      {url && <div role="status">
        <p><a href={url} target="_blank" rel="noreferrer">Перейти в Telegram и привязать аккаунт</a></p>
        <p>Нажмите «Старт» в боте. Ссылка действует 5 минут и работает только один раз. Не пересылайте её другим людям.</p>
      </div>}
    </form>}
    <p style={{ marginTop: 24 }}>Пароль вводится только здесь, на сайте. Бот не запрашивает пароли или документы в переписке.</p>
  </section>;
}
